module.exports = __webpack_public_path__ + "img/authe-6.b6060b4.jpg";